export const defaultParams = {
  routingMode: 'fast',
  transportMode: 'truck',
}
